import { defineMessages } from 'react-intl'

export const jobFilterMessages = defineMessages({
  save_title_success: {
    id: 'settings.job_filters.title.success',
    defaultMessage: 'Success',
  },
  save_title_error: {
    id: 'settings.job_filters.title.error',
    defaultMessage: 'Error',
  },
  save_message_success: {
    id: 'settings.job_filters.message.success',
    defaultMessage: 'Success',
  },
  save_message_error: {
    id: 'settings.job_filters.message.error',
    defaultMessage: 'Error',
  },
  heading: {
    id: 'settings.job_filters.heading',
    defaultMessage: 'Työlistauksen oletussuodatus',
  },
  visibility_heading: {
    id: 'settings.job_filters.visibility_heading',
    defaultMessage: 'Töiden näkyvyys',
  },
  visibility_open: {
    id: 'settings.job_filters.visibility.open',
    defaultMessage: 'Avoimet',
  },
  visibility_own: {
    id: 'settings.job_filters.visibility.own',
    defaultMessage: 'Omat',
  },
  visibility_others: {
    id: 'settings.job_filters.visibility.others',
    defaultMessage: 'Muiden',
  },
  stations_heading: {
    id: 'settings.job_filters.stations_heading',
    defaultMessage: 'Toimipisteet',
  },
  no_stations: {
    id: 'settings.job_filters.no_stations',
    defaultMessage: 'Ei toimipisteitä',
  },
  job_types_heading: {
    id: 'settings.job_filters.job_types_heading',
    defaultMessage: 'Työn tyypit',
  },
  no_job_types: {
    id: 'settings.job_filters.no_job_types',
    defaultMessage: 'Ei työn tyyppejä',
  },
})
